import QuoteCard from "./QuoteCard";
export default QuoteCard;
